import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { ConsultasSqlApi, SucursalApi } from 'app/shared/lb-sdk';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-login-cliente',
  templateUrl: './login-cliente.component.html',
  styleUrls: ['./login-cliente.component.css']
})
export class LoginClienteComponent implements OnInit {

  sucursalesDB = []
  constructor(private toastr: ToastrService, private sucursalApi: SucursalApi, private router: Router, private consultaSql: ConsultasSqlApi, private authService: AuthService) { }
  sucursalSel: number | string = '';
  usuario: string = "";
  clave: string = "";
  puesto = "";
  ngOnInit() {
    this.sucursalApi.find()
      .subscribe(res => {
        this.sucursalesDB = res;

      })
  }
  login() {

    if (this.usuario == ""){
      this.toastr.error("Debe indicar un usuario")
      return;
    }

    if (this.clave == ""){
      this.toastr.error("Debe indicar una clave")
      return;
    }

    if (this.puesto == ""){
      this.toastr.error("Debe indicar un puesto")
      return;
    }

    if (!this.sucursalSel) {
      this.toastr.error('Debe seleccionar una sucursal');
      return;
    }

    this.consultaSql.GetStoreDinamic({
      nombreStore: "GetLoginCliente", data: {
        parusuario: this.usuario,
        parclave: this.clave,
        parsucursal: this.sucursalSel,
        puesto: this.puesto
      }
    })
      .subscribe(respuesta => {
        if (respuesta[0] == "") {
          this.toastr.error('Datos incorrectos', 'Los datos ingresados no son correctos');
        }
        else {
          respuesta[0][0].idsucursal = this.sucursalSel;
          this.authService.userData = respuesta[0][0];
          this.authService.markLoginAt();
          this.router.navigateByUrl('display-cliente-v2')
        }

      })
  }
 

}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/login-cliente/login-cliente.component.ts